import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=349a3f27&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=349a3f27&prod&scoped=true&lang=css&"
import style1 from "./_slug.vue?vue&type=style&index=1&id=349a3f27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349a3f27",
  null
  
)

export default component.exports